{
	"ariaOpenHelpCenter": "Open Help Center",
	"browseHelpCenter": "Browse Help Center",
	"contactUs": "Contact Us",
	"failedToLoad": "Failed to load help articles",
	"noResults": "No results found",
	"noResultsFor": "No results for \"{{query}}\"",
	"placeholderSearchArticles": "Search our articles",
	"seeMoreResults": "See more results"
}
